export default __webpack_public_path__ + "static/community-eab48b7261d61a64c27bf4c99f6f78c6.svg";